module.exports = __webpack_public_path__ + "static/media/hamburger-icon.98866a30.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/hamburger-icon.svg
 ** module id = 144
 ** module chunks = 0
 **/